import { PersonDetails } from '@app/person'
import Button from 'components/button/base/Button'
import Dialog from 'components/dialog/base/Dialog'
import { Form, Formik, FormikHelpers as FormikActions } from 'formik'
import {
    requestAllPeopleRevalidation,
    useRequestPersonInvitationCancelling
} from 'helpers/peopleHelpers'
import { useGlobal } from 'hooks/useGlobal'
import React from 'react'
import { Trans, WithTranslation, withTranslation } from 'react-i18next'
import { compose } from 'recompose'

interface OwnProps {
    user: PersonDetails
}

type Props = OwnProps & WithTranslation

const CancelInvitationDialog = (props: Props) => {
    const initialValues = {}

    const { t, user } = props

    const {
        createNotification,
        closeActiveOverlay,
        tryCloseDirtyOverlay
    } = useGlobal()

    const requestPersonInvitationCancelling = useRequestPersonInvitationCancelling()
    const onSubmit = async (
        values: unknown,
        formikActions: FormikActions<unknown>
    ) => {
        try {
            await requestPersonInvitationCancelling(user.id)
            await requestAllPeopleRevalidation()
            closeActiveOverlay()
        } catch (payload) {
            // TODO: Introduce logging
            formikActions.setSubmitting(false)

            createNotification({
                type: t('error:labels.error'),
                description: t('error:response.cancelInvitationUnknown', {
                    username: user.name
                })
            })
        }
    }

    return (
        <Dialog
            title={t('people:cancelInvitation.title')}
            closeDialog={tryCloseDirtyOverlay}
            showCloseIcon={false}
        >
            <Formik initialValues={initialValues} onSubmit={onSubmit}>
                {(formikProps) => (
                    <Form className="dialog__form dialog__form--confirm">
                        <div className="dialog__info">
                            <Trans i18nKey="people:cancelInvitation.question">
                                <strong>{{ username: user.name }}</strong>
                            </Trans>
                        </div>

                        <div className="dialog__actions dialog__actions--noShadow">
                            <Button
                                title={t('common:labels.cancel')}
                                onClick={closeActiveOverlay}
                                formButton
                            />

                            <Button
                                title={t('common:labels.revoke')}
                                type="submit"
                                loading={formikProps.isSubmitting}
                                primary
                                formButton
                                destructive
                                autoFocus
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </Dialog>
    )
}

export default compose<Props, OwnProps>(
    withTranslation(['common', 'people', 'error'])
)(CancelInvitationDialog)
